import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG, WithChildren } from '../../../helpers'

type Props = {
	to: string
	title: string
	icon?: string
	customIcon?: JSX.Element
	fontIcon?: string
	hasBullet?: boolean
}

const AsideMenuItem: FC<Props & WithChildren> = ({
	children,
	to,
	title,
	icon,
	customIcon,
	fontIcon,
	hasBullet = false,
}) => {
	const { pathname } = useLocation()
	const isActive = checkIsActive(pathname, to)

	return (
		<div className="menu-item">
			<Link
				className={clsx('menu-link without-sub bg-hover-kumopack-grey-50', {
					'active bg-kumopack-grey-50': isActive,
				})}
				to={to}>
				{isActive && hasBullet && (
					<span className={clsx('menu-bullet', { 'ms-8': isActive, 'ms-3': !isActive })}>
						{isActive && <span className="kumopack-custom bullet bullet-dot p-1"></span>}
					</span>
				)}
				{(customIcon || icon) && (
					<span className="menu-icon">
						{customIcon ? customIcon : icon && <KTSVG path={icon} className="svg-icon-2" />}
					</span>
				)}
				{fontIcon && <i className={clsx('bi fs-3', fontIcon)}></i>}
				<span className="menu-title fw-bold text-kumopack-grey-900">{title}</span>
			</Link>
			{children}
		</div>
	)
}

export { AsideMenuItem }
